import {
  ShoppingCartOutlined,
  DollarOutlined,
  CreditCardOutlined,
  MobileOutlined,
  BankOutlined,
  WalletOutlined,
} from '@ant-design/icons';

// Transaction Type Options
export const TRANSACTION_TYPE_OPTIONS = [
  { label: 'Purchase Order', value: 'po' },
  { label: 'Sale', value: 'sell' },
] as const;

// Payment Mode Options
export const PAYMENT_MODE_OPTIONS = [
  { label: 'Cash', value: 'CASH' },
  { label: 'Gpay', value: 'GPAY' },
] as const;

// Transaction Type Colors
export const TRANSACTION_TYPE_COLORS = {
  po: 'blue',
  sell: 'green',
} as const;

// Payment Mode Colors
export const PAYMENT_MODE_COLORS = {
  CASH: 'green',
  GPAY: 'blue',
} as const;

// Transaction Type Icons
export const TRANSACTION_TYPE_ICONS = {
  po: <ShoppingCartOutlined />,
  sell: <DollarOutlined />,
} as const;

// Payment Mode Icons
export const PAYMENT_MODE_ICONS = {
  CASH: <WalletOutlined />,
  GPAY: <MobileOutlined />,
} as const;
